export default {
    data() {
        return {
            studentGenderOptions: [
                { id: 'male', display_label: 'Male' },
                { id: 'female', display_label: 'Female' },
                { id: 'transgender_male', display_label: 'Transgender-Male' },
                { id: 'transgender_female', display_label: 'Transgender-Female' },
                { id: 'non_binary', display_label: 'Non-Binary' },
                { id: 'unknown', display_label: 'Exploring/Unknown' },
                { id: 'prefer_not_to_say', display_label: 'Prefer not to answer' },
                { id: 'other', display_label: 'Not Listed / Self-Identify / Other' }
            ],
            counselorGenderOptions: [
                { id: 'male', display_label: 'Male' },
                { id: 'female', display_label: 'Female' },
                { id: 'transgender_male', display_label: 'Transgender-Male' },
                { id: 'transgender_female', display_label: 'Transgender-Female' },
                { id: 'non_binary', display_label: 'Non-Binary' },
                { id: 'other', display_label: 'Not Listed / Self-Identify / Other' }
            ],
            counselorPreferenceGenderOptions: [
                { id: '', display_label: 'Any' },
                { id: 'male', display_label: 'Male' },
                { id: 'female', display_label: 'Female' },
                { id: 'transgender_male', display_label: 'Transgender-Male' },
                { id: 'transgender_female', display_label: 'Transgender-Female' },
                { id: 'non_binary', display_label: 'Non-Binary' },
                { id: 'other', display_label: 'Not Listed / Self-Identify / Other' }
            ]
        };
    },
    methods: {
        getStudentGenderDisplayName(genderId) {
            const option = this.studentGenderOptions.find(g => g.id === genderId);
            if(option)
                return option.display_label;
            if(genderId === 'n/a')
                return "N/A";
            return "";
        },
        getCounselorGenderDisplayName(genderId) {
            const option = this.counselorGenderOptions.find(g => g.id === genderId);
            if(option)
                return option.display_label;
            if(genderId === 'n/a')
                return "N/A";
            return "";
        }
    }
};
